import React from 'react';
import PropTypes from 'prop-types';

import IconDimensions from 'components/icons/IconDimensions';
import { colorGrayLight2 } from 'styles/layout/colors';
import { BUILD_YOUR_OWN_SOFA_LINK } from 'commons/constants';
import PDPDesktopHeroThumbnail from '../PDPDesktopHeroThumbnail';
import IconFourSquare from '../../../../icons/iconFourSquare';

const DEFAULT_DIMENSION_SHOT_URLS = [];
const DEFAULT_PHOTOS = [];

const PDPDesktopConfigThumbnails = ({
  dimensionsImage,
  shouldShowDimensionThumbnail = false,
  dimensionShotUrls = DEFAULT_DIMENSION_SHOT_URLS,
  enableCrops,
  isConfigFlipped = false,
  isCylindoConfigurationPhotos = false,
  loading = false,
  pdpIsModularBYOProduct = false,
  photos = DEFAULT_PHOTOS,
  selectedPhoto = null,
  setSelectedPhoto,
  viewGalleryImageEvent,
}) => {
  if (loading) {
    return (
      <div className="flex">
        {[0, 1, 2, 3, 4].map(idx => (
          <PDPDesktopHeroThumbnail key={idx} loading />
        ))}
      </div>
    );
  }

  const showDimensionThumbnail =
    shouldShowDimensionThumbnail ??
    (!!dimensionsImage || dimensionShotUrls.length > 0);
  const numOfPhotosToShow = showDimensionThumbnail ? 5 : 6;
  const photosToShow = photos.slice(0, numOfPhotosToShow);

  return (
    <div className="flex">
      {photosToShow.map(({ id, src, cropData, type }, index) => (
        <PDPDesktopHeroThumbnail
          cropData={cropData}
          enableCrops={enableCrops}
          key={id}
          onClick={() => {
            setSelectedPhoto?.({ type, id, index, src });
          }}
          onMouseEnter={() => {
            setSelectedPhoto?.({ type, id, index, src });
            viewGalleryImageEvent({
              imageLocation: 'Configuration Gallery',
              imageFilename: src?.split('/').pop() || '',
              position: index,
              totalImages: photos.length,
            });
          }}
          onLoadFailure={() => {
            if (pdpIsModularBYOProduct && selectedPhoto === id) {
              let newType = 'configuration';
              let newIndex = 0;
              if (index === 0) {
                if (photosToShow.length > 1) {
                  newIndex = 1;
                } else {
                  newType = 'studio';
                }
              }
              setSelectedPhoto?.({
                type: newType,
                index: newIndex,
              });
            }
          }}
          type="configuration"
          src={src}
          isSelected={
            pdpIsModularBYOProduct
              ? selectedPhoto === id
              : selectedPhoto === src
          }
          isConfigFlipped={isConfigFlipped}
          isCylindoPhoto={isCylindoConfigurationPhotos}
        />
      ))}
      {pdpIsModularBYOProduct ? (
        <PDPDesktopHeroThumbnail
          enableCrops={false}
          key="build-your-own"
          onClick={() => {
            setSelectedPhoto?.({ type: 'buildyourown', index: 0 });
          }}
          onMouseEnter={() => {
            setSelectedPhoto?.({ type: 'buildyourown', index: 0 });
          }}
          type="buildyourown"
          icon={<IconFourSquare />}
          isSelected={selectedPhoto === BUILD_YOUR_OWN_SOFA_LINK}
        />
      ) : null}

      {showDimensionThumbnail && (
        <PDPDesktopHeroThumbnail
          key={dimensionsImage || 'dimensions'}
          onClick={() => {
            setSelectedPhoto?.({ type: 'dimensional', index: 0 });
          }}
          onMouseEnter={() => {
            setSelectedPhoto?.({ type: 'dimensional', index: 0 });
          }}
          isSelected={selectedPhoto?.type === 'dimensional'}
          icon={
            <IconDimensions width={24} height={24} color={colorGrayLight2} />
          }
          isConfigFlipped={isConfigFlipped}
        />
      )}
    </div>
  );
};

PDPDesktopConfigThumbnails.propTypes = {
  dimensionsImage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  shouldShowDimensionThumbnail: PropTypes.bool,
  dimensionShotUrls: PropTypes.arrayOf(PropTypes.object),
  enableCrops: PropTypes.bool,
  pdpIsModularBYOProduct: PropTypes.bool,
  isConfigFlipped: PropTypes.bool,
  isCylindoConfigurationPhotos: PropTypes.bool,
  loading: PropTypes.bool,
  photos: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      src: PropTypes.string.isRequired,
    })
  ),
  selectedPhoto: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  setSelectedPhoto: PropTypes.func,
  viewGalleryImageEvent: PropTypes.func,
};

export default PDPDesktopConfigThumbnails;
